import type * as React from 'react';
import { FormProvider, type UseFormReturn } from 'react-hook-form';

export type FormProps = {
    form: UseFormReturn<any, any, any>;
} & React.FormHTMLAttributes<HTMLFormElement>;

/**
 * A form enhanced with React Hook Form.
 */
export function Form(props: FormProps) {
    const { form, ...rest } = props;
    return (
        <FormProvider {...form}>
            <form
                className="contents"
                autoComplete="off"
                noValidate
                {...rest}
                onSubmit={(event) => {
                    event.stopPropagation();
                    rest?.onSubmit?.(event);
                }}
            />
        </FormProvider>
    );
}
